<div class="rating-cp" *ngFor="let star of rating; let i =index">
    <img alt="{{'Star' | translate}}" *ngIf=" i + 1 <= value" src="../../assets/images/star.svg">
    <img alt="{{'Star' | translate}}" *ngIf=" i + 1 < value && i + 1 > ( value - 1 )" src="../../assets/images/starHalf.svg">
</div>
